import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const BackgroundLayout = ({ children, className = "" }) => {
    const { isDarkMode } = useTheme();

    return (
        <div className={`min-h-screen font-sans relative overflow-x-hidden transition-colors duration-300 ${isDarkMode
            ? 'bg-slate-900 text-slate-100 selection:bg-blue-500 selection:text-white'
            : 'bg-slate-50 text-slate-900 selection:bg-blue-100 selection:text-blue-900'
            } ${className}`}>

            {/* Dynamic Background */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none z-0 transition-opacity duration-500">
                {isDarkMode ? (
                    // Dark Mode Background
                    <>
                        <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-blue-600/20 rounded-full blur-[120px] animate-blob" />
                        <div className="absolute top-[20%] right-[-10%] w-[600px] h-[600px] bg-purple-600/20 rounded-full blur-[120px] animate-blob animation-delay-2000" />
                        <div className="absolute bottom-[-10%] left-[20%] w-[500px] h-[500px] bg-pink-600/20 rounded-full blur-[120px] animate-blob animation-delay-4000" />
                        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay"></div>
                    </>
                ) : (
                    // Light Mode Background
                    <>
                        <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-blue-100/40 rounded-full blur-[100px] animate-blob" />
                        <div className="absolute top-[20%] right-[-10%] w-[600px] h-[600px] bg-purple-100/40 rounded-full blur-[100px] animate-blob animation-delay-2000" />
                        <div className="absolute inset-0 bg-slate-50/50 backdrop-blur-3xl"></div>
                    </>
                )}
            </div>

            {/* Content Content */}
            <div className="relative z-10">
                {children}
            </div>
        </div>
    );
};

export default BackgroundLayout;
